module.exports = global["p2"] = require("-!./p2.js");


//////////////////
// WEBPACK FOOTER
// ./~/phaser/build/custom/p2.js
// module id = 3
// module chunks = 0